export default {
    state: {
        progress_bar_counter: 0,
        is_progress_bar_with_overlay_shown: false,
    },
    mutations: {
        HIDE_PROGRESS_BAR: (state) => {
            state.progress_bar_counter--;
            if (state.progress_bar_counter <= 0)
            {
                state.progress_bar_counter = 0;
                state.is_progress_bar_with_overlay_shown = false
            }
        },
        SHOW_PROGRESS_BAR: (state) => {
            state.progress_bar_counter++
        },
        SHOW_PROGRESS_BAR_WITH_OVERLAY: (state) => {
            state.progress_bar_counter++;
            state.is_progress_bar_with_overlay_shown = true
        },
    },
    actions: {
        showProgressBar({commit, state}, is_overlay = true) {
            if (is_overlay) {
                commit('SHOW_PROGRESS_BAR_WITH_OVERLAY');
            } else {
                commit('SHOW_PROGRESS_BAR');
            }
        },
        hideProgressBar({commit, state}) {
            commit('HIDE_PROGRESS_BAR');
        }
    },
    getters: {
        is_progress_bar_with_overlay_shown: state => state.is_progress_bar_with_overlay_shown,
        is_progress_bar_shown: state => state.progress_bar_counter > 0,
    }
}